import { render, staticRenderFns } from "./PhotosPanel.vue?vue&type=template&id=5478e3da&scoped=true&"
import script from "./PhotosPanel.vue?vue&type=script&lang=js&"
export * from "./PhotosPanel.vue?vue&type=script&lang=js&"
import style0 from "./PhotosPanel.vue?vue&type=style&index=0&id=5478e3da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478e3da",
  null
  
)

export default component.exports